import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy redirect: the standalone "New Install" form has been decommissioned.
 * Agents are now created from the "+ Add Agent" flow on the customer detail
 * page (CLA-421); this URL lands on the unified Agents fleet (CLA-418).
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/admin/installs/new")({
  beforeLoad: () => {
    throw redirect({ to: "/clawinstall/admin/agents" });
  },
});
